// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3968":"e96b6040","5938":"e96b6040"}[chunkId] + ".chunk.css";
};